import { Icon, IconName, ProductColor, colors } from '@aloft/toolkit-sui';

import toast from 'react-hot-toast';

import { RenderToast } from './RenderToast.js';
import { TOAST_CLASS_NAME, TOAST_DURATION_IN_MS } from './constants.js';
import { MakeToast, ToastType } from './types.js';

const toastTypeToIconProps: {
  [key in ToastType]: {
    icon: IconName;
    color: ProductColor;
  };
} = {
  warning: {
    icon: 'error-warning',
    color: 'alertWarning',
  },
  info: {
    icon: 'information',
    color: 'surfaceAccent6',
  },
  success: {
    icon: 'check-circle',
    color: 'success',
  },
  error: {
    icon: 'close-circle',
    color: 'alertError',
  },
};

const toastTypeToStyleProps: {
  [key in ToastType]: React.CSSProperties;
} = {
  warning: {
    backgroundColor: colors.alertWarningLight,
    borderColor: colors.alertWarning,
  },
  info: {
    backgroundColor: colors.surface3,
    borderColor: colors.surfaceAccent6,
  },
  success: {
    backgroundColor: colors.alertSuccessLight,
    borderColor: colors.success,
  },
  error: {
    backgroundColor: colors.alertErrorLight,
    borderColor: colors.alertError,
  },
};

export const makeReactHotToast: MakeToast = ({
  id,
  type,
  title,
  body,
  action,
  singleSlice = true,
  durationInMs = TOAST_DURATION_IN_MS,
}) => {
  const iconProps = toastTypeToIconProps[type];
  const styleProps = toastTypeToStyleProps[type];

  toast((t) => RenderToast({ title, body, onClose: () => toast.dismiss(t.id), action }), {
    id: singleSlice ? id : undefined,
    duration: durationInMs,
    position: 'bottom-right',
    style: {
      border: '1px solid',
      maxWidth: '600px',
      ...styleProps,
    },
    className: TOAST_CLASS_NAME,
    icon: <Icon size="lg" {...iconProps} />,
  });
};
